enum SortDirection {
  Ascending = "asc",
  Descending = "desc"
}

export default SortDirection;
